import { Action, createReducer, on } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
import { UserManagement } from './user-management.model';
import * as UserManagementActions from './user-management.actions';

export const userManagementsFeatureKey = 'userManagements';

export interface State extends EntityState<UserManagement> {
  // additional entities state properties
}

export const adapter: EntityAdapter<UserManagement> = createEntityAdapter<UserManagement>();

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export const reducer = createReducer(
  initialState,
  on(UserManagementActions.addUserManagement,
    (state, action) => adapter.addOne(action.userManagement, state)
  ),
  on(UserManagementActions.upsertUserManagement,
    (state, action) => adapter.upsertOne(action.userManagement, state)
  ),
  on(UserManagementActions.addUserManagements,
    (state, action) => adapter.addMany(action.userManagements, state)
  ),
  on(UserManagementActions.upsertUserManagements,
    (state, action) => adapter.upsertMany(action.userManagements, state)
  ),
  on(UserManagementActions.updateUserManagement,
    (state, action) => adapter.updateOne(action.userManagement, state)
  ),
  on(UserManagementActions.updateUserManagements,
    (state, action) => adapter.updateMany(action.userManagements, state)
  ),
  on(UserManagementActions.deleteUserManagement,
    (state, action) => adapter.removeOne(action.id, state)
  ),
  on(UserManagementActions.deleteUserManagements,
    (state, action) => adapter.removeMany(action.ids, state)
  ),
  on(UserManagementActions.loadUserManagements,
    (state, action) => adapter.setAll(action.userManagements, state)
  ),
  on(UserManagementActions.clearUserManagements,
    state => adapter.removeAll(state)
  ),
);

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
